import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Logo } from "../components/Logo";
import { Loader2, LogOut } from "lucide-react";

export default function Logout() {
  const { logout } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try { await logout(); }
      finally {
        if (!cancelled) {
          // small delay for UX so the user sees the logout state
          setTimeout(() => nav("/quote-portal/login", { replace: true }), 600);
        }
      }
    })();
    return () => { cancelled = true; };
  }, [logout, nav]);

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-4" data-testid="logout-page">
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#254391] via-[#fda500] to-[#254391]" />
      <div className="w-full max-w-sm bg-white rounded-xl shadow-lg border border-gray-100 p-10 text-center">
        <Logo height={56} />
        <div className="mt-3 text-[11px] tracking-[0.22em] uppercase text-[#fda500] font-semibold mb-6">
          Built for Access. Made with Care.
        </div>
        <div className="w-12 h-12 mx-auto rounded-full bg-blue-50 text-[#254391] flex items-center justify-center mb-3">
          <LogOut size={22} />
        </div>
        <h1 className="text-base font-bold text-[#0A1128] mb-1">Signing you out…</h1>
        <p className="text-xs text-gray-500 flex items-center justify-center gap-1.5">
          <Loader2 size={12} className="animate-spin" /> Redirecting to sign-in
        </p>
      </div>
    </div>
  );
}
